import identityConfirmationWidgetMigrations from './identityConfirmationWidget';

/**
* Migrations for an individual "layoutItem" object of the event site editor website.
* - Migrate new style settings onto EventIdentityConfirmation widgets.
*/
export default function layoutItemMigrations(layoutItem) {
  if (layoutItem.layout.type !== 'widget') {
    return layoutItem;
  }
  switch (layoutItem.widgetType) {
    case 'EventIdentityConfirmation':
      return identityConfirmationWidgetMigrations(layoutItem);
    default:
      return layoutItem;
  }
}
